export default __webpack_public_path__ + "static/fresh-pets-json-ld-logo-c4d32acc6ed0a2167d7a76172d3b28ba.png";